import { proxy } from "@/util/proxy.mjs";

interface AppShellUserDropdownRefs {
  UserDropdownWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> | null;
  UserNameWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> | null;
}

export const appShellUserDropdownRefs = proxy<AppShellUserDropdownRefs>({
  UserDropdownWrapper: null,
  UserNameWrapper: null,
});
